module.exports = __webpack_public_path__ + "img/2.dd50c49d.png";